import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const LayerControl = ({ layers, onLayerToggle, isOpen, onToggle }) => {
  return (
    <div className={`absolute bottom-24 right-4 bg-card rounded-lg shadow-conservation-lg transition-all duration-300 z-[400] ${isOpen ? 'w-80' : 'w-12'}`}>
      <button
        onClick={onToggle}
        className="w-full p-3 flex items-center justify-between hover:bg-muted/50 rounded-t-lg transition-colors"
        aria-label={isOpen ? 'Close layers' : 'Open layers'}
      >
        <span className={`font-medium text-foreground ${isOpen ? 'block' : 'hidden'}`}>Map Layers</span>
        <Icon name={isOpen ? 'ChevronRight' : 'Layers'} size={20} color="var(--color-foreground)" />
      </button>
      {isOpen && (
        <div className="p-4 space-y-4 max-h-96 overflow-y-auto">
          {layers?.map((layer) => (
            <div key={layer?.id} className="space-y-2">
              <Checkbox
                label={layer?.name}
                description={layer?.description}
                checked={layer?.enabled}
                onChange={(e) => onLayerToggle(layer?.id, e?.target?.checked)}
              />
              {layer?.enabled && layer?.opacity !== undefined && (
                <div className="ml-6 space-y-1">
                  <label className="text-xs text-muted-foreground flex items-center justify-between">
                    <span>Opacity</span>
                    <span>{Math.round(layer?.opacity * 100)}%</span>
                  </label>
                  <input
                    type="range"
                    min="0"
                    max="100"
                    value={layer?.opacity * 100}
                    onChange={(e) => onLayerToggle(layer?.id, true, parseFloat(e?.target?.value) / 100)}
                    className="w-full h-1 bg-muted rounded-lg appearance-none cursor-pointer"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LayerControl;